import { SkyscannerAdvertsAdsretrievalserviceV1alpha1Api } from '@skyscanner-internal/ads-retrieval-service-web-http-client';

import { grpcFetchClientWrapper } from '../internals/clients/grpc/grpc';
import { jhaMiddleware } from '../internals/clients/grpc/jhaMiddleware';

import type {
  SkyscannerAdvertsAdsretrievalserviceV1alpha1Request,
  SkyscannerAdvertsAdsretrievalserviceV1alpha1Response,
} from '@skyscanner-internal/ads-retrieval-service-web-http-client';

type GetAdsRequest = SkyscannerAdvertsAdsretrievalserviceV1alpha1Request.GetAdsRequest;
type GetAdsResponse = SkyscannerAdvertsAdsretrievalserviceV1alpha1Response.GetAdsResponse;

export const ADS_CAPABILITY_PATH_PREFIX = '/g/ars';

const createAdsCapabilityRequest = (clientName: string) =>
  grpcFetchClientWrapper<GetAdsRequest, GetAdsResponse>(
    SkyscannerAdvertsAdsretrievalserviceV1alpha1Api.AdsService.GetAds,
    { clientName, pathPrefix: ADS_CAPABILITY_PATH_PREFIX, betaInterceptors: [jhaMiddleware] },
  );

export const adsCapabilityRequest = createAdsCapabilityRequest('ADS_CAPABILITY');
export const adsCapabilityExploreRequest = createAdsCapabilityRequest('WEB_PLATFORM_EXPLORE');
